import constantString from './common/language/constantString';

export const homeMenu = {
	intro: { id: 'intro', text: 'Intro', path: '#intro', icon: 'Vrpano', subMenu: null },
	bootstrap: {
		id: 'bootstrap',
		text: 'Bootstrap Components',
		path: '#bootstrap',
		icon: 'BootstrapFill',
		subMenu: null,
	},
	storybook: {
		id: 'storybook',
		text: 'Storybook',
		path: '#storybook',
		icon: 'CustomStorybook',
		subMenu: null,
	},
	formik: {
		id: 'formik',
		text: 'Formik',
		path: '#formik',
		icon: 'CheckBox',
		subMenu: null,
	},
	apex: {
		id: 'apex',
		text: 'Apex Charts',
		path: '#apex',
		icon: 'AreaChart',
		subMenu: null,
	},
};

export const dashboardMenu = {
	dashboard: {
		id: 'dashboard',
		text: constantString.DASHBOARD,
		path: 'dashboard',
		icon: 'Dashboard',
		subMenu: null,
	},
	// dashboardd: {
	// 	id: 'dashboardd',
	// 	text: 'Promotions',
	// 	path: '/',
	// 	icon: 'Dashboard',
	// 	subMenu: null,
	// },
};

export const demoPages = {
	// pages: {
	// 	id: 'pages',
	// 	text: 'Vender',
	// 	icon: 'Extension',
	// },
	
	// vbookingPages: {
	// 	id: 'v_bookings',
	// 	text: 'Appointments',
	// 	path: 'knowledge',
	// 	icon: 'Schedule',
	// 	subMenu: {
	// 		v_book: {
	// 			id: 'v_up_book',
	// 			text: 'Pending Appointments',
	// 			path: 'appointment/pending',
	// 		},
	// 		v_completed_book: {
	// 			id: 'v_completed_book',
	// 			text: 'Completed Appointments',
	// 			path: 'appointment/completed',
	// 		},
	// 		v_expired_book: {
	// 			id: 'v_expired_book',
	// 			text: 'Expired Appointments',
	// 			path: 'appointment/expired',
	// 		},
	// 		v_cancelled_book: {
	// 			id: 'v_cancelled_book',
	// 			text: 'Cancelled Appointments',
	// 			path: 'appointment/cancelled',
	// 		},
	// 		v_assign_book: {
	// 			id: 'v_assign_book',
	// 			text: 'Assign Appointments',
	// 			path: 'appointment/assign',
	// 			hide: true,
	// 		},
	// 		v_cartp: {
	// 			id: 'v_cartp',
	// 			text: 'Cart',
	// 			path: 'vp-pages/cartp',
	// 			hide: true,
	// 		},
	// 	},
	// },

	// Orders_v: {
	// 	id: 'Orders_v',
	// 	text: 'Orders',
	// 	path: 'orders',
	// 	icon: 'Article',
	// },

	// servicePages: {
	// 	id: 'servicePages',
	// 	text: 'Services',
	// 	path: 'knowledge',
	// 	icon: 'Dns',
	// 	subMenu: {
	// 		add_serv: {
	// 			id: 'add_serv',
	// 			text: 'Services',
	// 			path: 'services/list',
	// 		},
	// 		add_cat: {
	// 			id: 'add_cat',
	// 			text: 'Category',
	// 			path: 'services/category',
	// 		},
	// 		add_promo: {
	// 			id: 'add_promo',
	// 			text: 'Promotions',
	// 			path: 'services/promotions',
	// 		},

	// 		view_serv: {
	// 			id: 'view_serv',
	// 			text: 'Services',
	// 			path: 'service-pages/views',
	// 			hide: true,
	// 		},
	// 	},
	// },
	// addProduct: {
	// 	id: 'addproduct',
	// 	text: 'Products',
	// 	path: 'viewproducts',
	// 	icon: 'Storefront',
	// },
	// sliderSetting: {
	// 	id: 'slidersett',
	// 	text: 'Slider',
	// 	path: 'sliders',
	// 	icon: 'FilterNone',
	// },

	// sliderSetting: {
	// 	id: 'slidersett',
	// 	text: 'Slider',
	// 	path: 'sliders',
	// 	icon: 'FilterNone',
	// },

	// Manage_e: {
	// 	id: 'Manage_e',
	// 	text: 'Employees',
	// 	path: 'knowledge',
	// 	icon: 'SupervisedUserCircle',
	// 	subMenu: {
	// 		emp_list: {
	// 			id: 'emp_list',
	// 			text: 'Employees',
	// 			path: 'employee/list',
	// 		},
	// 		emp_shed: {
	// 			id: 'emp_shed',
	// 			text: 'Shifts',
	// 			path: 'employee/shifts',
	// 		},
	// 		emp_work_shed: {
	// 			id: 'emp_work_shed',
	// 			text: 'Worker Schedule',
	// 			path: 'employee/worker-schedule',
	// 		},
	// 		emp_leave: {
	// 			id: 'emp_leave',
	// 			text: 'Leave Requests',
	// 			path: 'employee/leave-requests',
	// 		},
	// 	},
	// },

	// Manage_u: {
	// 	id: 'Manage_u',
	// 	text: 'Customers',
	// 	path: 'knowledge',
	// 	icon: 'AccountBox',
	// 	subMenu: {
	// 		all_u: {
	// 			id: 'all_u',
	// 			text: 'Customers',
	// 			path: 'cusm-pages/alist',
	// 		},
	// 		blacklist: {
	// 			id: 'blacklist',
	// 			text: 'Blacklist Customers',
	// 			path: 'cusm-pages/blacklist',
	// 			hide: true,
	// 		},
	// 		details_u: {
	// 			id: 'details_u',
	// 			text: 'Customer Details',
	// 			path: 'details-pages/customer',
	// 			hide: true,
	// 		},
	// 	},
	// },

	// Manage_u: {
	// 	id: 'Manage_u',
	// 	text: 'Customers',
	// 	path: 'customers',
	// 	icon: 'Account circle',
	// },

	Manage_v: {
		id: 'Manage_v',
		text: 'Super Administrators',
		path: 'admins',
		icon: 'Manage accounts',
	},

	// Manage_roles: {
	// 	id: 'Manage_roles',
	// 	text: 'Roles',
	// 	path: 'roles',
	// 	icon: 'Shield',
	// },
	// Manage_super: {
	// 	id: 'Manage_super',
	// 	text: 'Super Admin',
	// 	path: 'super',
	// 	icon: 'ManageAccounts',
	// 	hide: true,
	// },

	// Payroll_s: {
	// 	id: 'Payroll_s',
	// 	text: 'Payroll System',
	// 	path: '',
	// 	icon: 'LocalAtm',
	// },

	// Manage_mail: {
	// 	id: 'Manage_mail',
	// 	text: 'Emails',
	// 	path: 'knowledgemail',
	// 	icon: 'Mail',

	// 	subMenu: {
	// 		campaigns: {
	// 			id: 'ampaigns',
	// 			text: 'Campaigns',
	// 			path: 'vmail-pages/camp',
	// 			hide: true,
	// 		},
	// 		template: {
	// 			id: 'template',
	// 			text: 'Templates',
	// 			path: 'vmail-pages/vsend',
	// 			hide: true,
	// 		},
	// 	},
	// },

	// Transaction: {
	// 	id: 'Transaction',
	// 	text: 'Accounts',
	// 	path: 'knowledgtrance',
	// 	icon: 'RequestQuote',
	// 	subMenu: {
	// 		manage_pay: {
	// 			id: 'manage_pay',
	// 			text: 'Payroll',
	// 			path: 'transaction/payroll',
	// 		},
	// 		income: {
	// 			id: 'income',
	// 			text: 'Income',
	// 			path: 'transaction/income',
	// 		},
	// 		expences: {
	// 			id: 'expences',
	// 			text: 'Expences',
	// 			path: 'transaction/expences',
	// 		},
	// 		cheque: {
	// 			id: 'cheque',
	// 			text: 'Cheque',
	// 			path: 'transaction/cheque',
	// 		},
	// 		extype: {
	// 			id: 'extype',
	// 			text: 'Expences Type',
	// 			path: 'transaction/extype',
	// 		},
	// 	},
	// },
	// generate_r: {
	// 	id: 'generate_r',
	// 	text: 'Generate Reports',
	// 	path: 'vreport-pages/vrgen',
	// 	icon: 'Article',

	// },

	// Manage_report: {
	// 	id: 'Manage_report',
	// 	text: 'Reports',
	// 	path: 'knowledgereport',
	// 	icon: 'Article',
	// 	subMenu: {
	// 		orders: {
	// 			id: 'orders',
	// 			text: 'Orders',
	// 			path: 'reports/orders',
	// 		},
	// 		appointment: {
	// 			id: 'appointment',
	// 			text: 'Appointments',
	// 			path: 'reports/appointments',
	// 		},
	// 		product: {
	// 			id: 'product',
	// 			text: 'Products',
	// 			path: 'reports/products',
	// 		},
	// 		manage_comm: {
	// 			id: 'manage_comm',
	// 			text: 'Commission',
	// 			path: 'reports/commission',
	// 		},
	// 		payment: {
	// 			id: 'payment',
	// 			text: 'Payments',
	// 			path: 'reports/payments',
	// 		},
	// 		sheduler: {
	// 			id: 'shedule',
	// 			text: 'Schedule',
	// 			path: 'reports/schedule',
	// 		},
	// 		attendance: {
	// 			id: 'attendance',
	// 			text: 'Attendance',
	// 			path: 'reports/attendance',
	// 		},
	// 		prefund: {
	// 			id: 'prefund',
	// 			text: 'Pending Refund',
	// 			path: 'reports/pending-refund',
	// 		},
	// 		crefund: {
	// 			id: 'crefund',
	// 			text: 'Completed Refund',
	// 			path: 'reports/completed-refund',
	// 		},
	// 	},
	// },

	// v_refunds: {
	// 	id: 'v_refunds',
	// 	text: 'Refunds',
	// 	path: 'refund-pages/vlist',
	// 	icon: 'Payment',
	// },

	// Manage_refunds: {
	// 	id: 'Manage_refunds',
	// 	text: 'Refunds',
	// 	path: 'knowledge',
	// 	icon: 'Keyboard return',
	// 	subMenu: {
	// 		refund_list: {
	// 			id: 'refund_list',
	// 			text: 'Refund Requested',
	// 			path: 'refunds/requested',
	// 		},
	// 		refund_havetopay: {
	// 			id: 'refund_havetopay',
	// 			text: 'Refund Payments',
	// 			path: 'refund-pages/htlist',
	// 			hide: true,
	// 		},
	// 		refund_paid: {
	// 			id: 'refund_paid',
	// 			text: 'Completed Refunds',
	// 			path: 'refunds/completed',
	// 		},
	// 	},
	// },

	Packages: {
		id: 'Packages',
		text: 'Packages',
		path: 'packages',
		icon: 'Storage',
	},
	Managebiz: {
		id: 'Managebiz',
		text: 'Manage Business',
		path: 'managebiz',
		icon: 'Business',
	},
	Manageinv: {
		id: 'Manageinv',
		text: 'Manage Invoice',
		path: 'manageinvoice',
		icon: 'Receipt',
	},

	// Manage_sadmin: {
	// 	id: 'Manage_sadmin',
	// 	text: 'Super Admin',
	// 	path: 'knowledge',
	// 	icon: 'Ballot',
	// 	subMenu: {
	// 		packages: {
	// 			id: 'packages',
	// 			text: 'Packages',
	// 			path: 'super/packages',
	// 		},
	// 		manageBiz: {
	// 			id: 'managebiz',
	// 			text: 'Manage Business',
	// 			path: 'super/managebiz',
	// 		},
	// 		manageInv: {
	// 			id: 'manageinv',
	// 			text: 'Manage Invoice',
	// 			path: 'super/manageinvoice',
	// 		},
	// 	},
	// },
	// branchList: {
	// 	id: 'branch',
	// 	text: 'Branches',
	// 	path: 'branch',
	// 	icon: 'MapsHomeWork',
	// },
	// venderSetting: {
	// 	id: 'sett',
	// 	text: 'Settings',
	// 	path: 'settings',
	// 	icon: 'Settings',
	// },
	// packegeInvoice: {
	// 	id: 'pack',
	// 	text: 'Packege Invoice',
	// 	path: 'packege',
	// 	icon: 'CreditScore',
	// },

	// pricingTable: {
	// 	id: 'pricingTable',
	// 	text: 'Pricing Plans',
	// 	path: 'pricing',
	// 	icon: 'Local Offer',
	// },
	price_h: {
		id: 'price_h',
		text: 'Payment handling',
		path: 'handling-pages/payment',
		icon: 'Payment',
		hide: true,
	},

	login: {
		id: 'login',
		text: 'Login',
		// path: 'auth-pages/login',
		path: '/',
		icon: 'Login',
		hide: true,
	},
	signUp: {
		id: 'signUp',
		text: 'Sign Up',
		path: 'auth-pages/sign-up',
		icon: 'PersonAdd',
		hide: true,
	},
	forgot: {
		id: 'forgot',
		text: 'forgot',
		path: 'landing/forgot',
		icon: 'Dashboard',
		subMenu: null,
		hide: true,
	},
	changepw: {
		id: 'changepw',
		text: 'changepw',
		path: 'landing/changepw',
		icon: 'Dashboard',
		subMenu: null,
		hide: true,
	},
};

export const componentsMenu = {
	bootstrap: {
		id: 'bootstrap',
		text: 'Bootstrap',
		icon: 'Extension',
	},
	content: {
		id: 'content',
		text: 'Content',
		path: 'content',
		icon: 'format_size',
		subMenu: {
			typography: {
				id: 'typography',
				text: 'Typography',
				path: 'content/typography',
				icon: 'text_fields',
			},
			images: {
				id: 'images',
				text: 'Images',
				path: 'content/images',
				icon: 'Image ',
			},
			tables: {
				id: 'tables',
				text: 'Tables',
				path: 'content/tables',
				icon: 'table_chart',
			},
			figures: {
				id: 'figures',
				text: 'Figures',
				path: 'content/figures',
				icon: 'Photo Library ',
			},
		},
	},
	forms: {
		id: 'forms',
		text: 'Forms',
		path: 'forms',
		icon: 'CheckBox',
		notification: 'success',
		subMenu: {
			formGroup: {
				id: 'formGroup',
				text: 'Form Group',
				path: 'forms/form-group',
				icon: 'Source',
			},
			formControl: {
				id: 'formControl',
				text: 'Form Controls',
				path: 'forms/form-controls',
				icon: 'Create',
			},
			select: {
				id: 'select',
				text: 'Select',
				path: 'forms/select',
				icon: 'Checklist',
			},
			checksAndRadio: {
				id: 'checksAndRadio',
				text: 'Checks & Radio',
				path: 'forms/checks-and-radio',
				icon: 'CheckBox',
			},
			range: {
				id: 'range',
				text: 'Range',
				path: 'forms/range',
				icon: 'HdrStrong',
			},
			inputGroup: {
				id: 'inputGroup',
				text: 'Input Group',
				path: 'forms/input-group',
				icon: 'PowerInput',
			},
			validation: {
				id: 'validation',
				text: 'Validation',
				path: 'forms/validation',
				icon: 'VerifiedUser',
			},
			wizard: {
				id: 'wizard',
				text: 'Wizard',
				path: 'forms/wizard',
				icon: 'LinearScale',
			},
		},
	},
	components: {
		id: 'components',
		text: 'Component',
		path: 'components',
		icon: 'Extension',
		notification: 'success',
		subMenu: {
			accordion: {
				id: 'accordion',
				text: 'Accordion',
				path: 'components/accordion',
				icon: 'ViewDay',
			},
			alert: {
				id: 'alert',
				text: 'Alert',
				path: 'components/alert',
				icon: 'Announcement',
			},
			badge: {
				id: 'badge',
				text: 'Badge',
				path: 'components/badge',
				icon: 'Vibration',
			},
			breadcrumb: {
				id: 'breadcrumb',
				text: 'Breadcrumb',
				path: 'components/breadcrumb',
				icon: 'AddRoad',
			},
			button: {
				id: 'button',
				text: 'Button',
				path: 'components/button',
				icon: 'SmartButton',
			},
			buttonGroup: {
				id: 'buttonGroup',
				text: 'Button Group',
				path: 'components/button-group',
				icon: 'Splitscreen',
			},
			card: {
				id: 'card',
				text: 'Card',
				path: 'components/card',
				icon: 'Crop32',
			},
			carousel: {
				id: 'carousel',
				text: 'Carousel',
				path: 'components/carousel',
				icon: 'RecentActors',
			},
			// Close
			collapse: {
				id: 'collapse',
				text: 'Collapse',
				path: 'components/collapse',
				icon: 'UnfoldLess',
			},
			dropdowns: {
				id: 'dropdowns',
				text: 'Dropdowns',
				path: 'components/dropdowns',
				icon: 'Inventory',
			},
			listGroup: {
				id: 'listGroup',
				text: 'List Group',
				path: 'components/list-group',
				icon: 'ListAlt',
			},
			modal: {
				id: 'modal',
				text: 'Modal',
				path: 'components/modal',
				icon: 'PictureInPicture',
			},
			navsTabs: {
				id: 'navsTabs',
				text: 'Navs & Tabs',
				path: 'components/navs-and-tabs',
				icon: 'PivotTableChart',
			},
			// Navbar
			offcanvas: {
				id: 'offcanvas',
				text: 'Offcanvas',
				path: 'components/offcanvas',
				icon: 'VerticalSplit',
			},
			pagination: {
				id: 'pagination',
				text: 'Pagination',
				path: 'components/pagination',
				icon: 'Money',
			},
			popovers: {
				id: 'popovers',
				text: 'Popovers',
				path: 'components/popovers',
				icon: 'Assistant',
			},
			progress: {
				id: 'progress',
				text: 'Progress',
				path: 'components/progress',
				icon: 'HourglassTop',
			},
			scrollspy: {
				id: 'scrollspy',
				text: 'Scrollspy',
				path: 'components/scrollspy',
				icon: 'KeyboardHide',
			},
			spinners: {
				id: 'spinners',
				text: 'Spinners',
				path: 'components/spinners',
				icon: 'RotateRight',
			},
			table: {
				id: 'table',
				text: 'Table',
				path: 'components/table',
				icon: 'TableChart',
			},
			toasts: {
				id: 'toasts',
				text: 'Toasts',
				path: 'components/toasts',
				icon: 'RotateRight',
			},
			tooltip: {
				id: 'tooltip',
				text: 'Tooltip',
				path: 'components/tooltip',
				icon: 'Assistant',
			},
		},
	},
	utilities: {
		id: 'utilities',
		text: 'Utilities',
		path: 'utilities',
		icon: 'Support',
		subMenu: {
			api: {
				id: 'api',
				text: 'API',
				path: 'utilities/api',
				icon: 'Api',
			},
			background: {
				id: 'background',
				text: 'Background',
				path: 'utilities/background',
				icon: 'FormatColorFill',
			},
			borders: {
				id: 'borders',
				text: 'Borders',
				path: 'utilities/borders',
				icon: 'BorderStyle',
			},
			colors: {
				id: 'colors',
				text: 'Colors',
				path: 'utilities/colors',
				icon: 'InvertColors',
			},
			display: {
				id: 'display',
				text: 'Display',
				path: 'utilities/display',
				icon: 'LaptopMac',
			},
			flex: {
				id: 'flex',
				text: 'Flex',
				path: 'utilities/flex',
				icon: 'SettingsOverscan',
			},
			float: {
				id: 'float',
				text: 'Float',
				path: 'utilities/float',
				icon: 'ViewArray',
			},
			interactions: {
				id: 'interactions',
				text: 'Interactions',
				path: 'utilities/interactions',
				icon: 'Mouse',
			},
			overflow: {
				id: 'overflow',
				text: 'Overflow',
				path: 'utilities/overflow',
				icon: 'TableRows',
			},
			position: {
				id: 'position',
				text: 'Position',
				path: 'utilities/position',
				icon: 'Adjust',
			},
			shadows: {
				id: 'shadows',
				text: 'Shadows',
				path: 'utilities/shadows',
				icon: 'ContentCopy',
			},
			sizing: {
				id: 'sizing',
				text: 'Sizing',
				path: 'utilities/sizing',
				icon: 'Straighten',
			},
			spacing: {
				id: 'spacing',
				text: 'Spacing',
				path: 'utilities/spacing',
				icon: 'SpaceBar',
			},
			text: {
				id: 'text',
				text: 'Text',
				path: 'utilities/text',
				icon: 'TextFields',
			},
			verticalAlign: {
				id: 'vertical-align',
				text: 'Vertical Align',
				path: 'utilities/vertical-align',
				icon: 'VerticalAlignCenter',
			},
			visibility: {
				id: 'visibility',
				text: 'Visibility',
				path: 'utilities/visibility',
				icon: 'Visibility',
			},
		},
	},
	extra: {
		id: 'extra',
		text: 'Extra Library',
		icon: 'Extension',
	},
	icons: {
		id: 'icons',
		text: 'Icons',
		path: 'icons',
		icon: 'Grain',
		notification: 'success',
		subMenu: {
			icon: {
				id: 'icon',
				text: 'Icon',
				path: 'icons/icon',
				icon: 'Lightbulb',
			},
			material: {
				id: 'material',
				text: 'Material',
				path: 'icons/material',
				icon: 'Verified',
			},
			bootstrapIcon: {
				id: 'bootstrapIcon',
				text: 'Bootstrap Icon',
				path: 'icons/bootstrap-icon',
				icon: 'BootstrapFill',
			},
		},
	},
	charts: {
		id: 'charts',
		text: 'Charts',
		path: 'charts',
		icon: 'AreaChart',
		notification: 'success',
		subMenu: {
			chartsUsage: {
				id: 'chartsUsage',
				text: 'General Usage',
				path: 'charts/general-usage',
				icon: 'Description',
			},
			chartsSparkline: {
				id: 'chartsSparkline',
				text: 'Sparkline',
				path: 'charts/sparkline',
				icon: 'AddChart',
			},
			chartsLine: {
				id: 'chartsLine',
				text: 'Line',
				path: 'charts/line',
				icon: 'ShowChart',
			},
			chartsArea: {
				id: 'chartsArea',
				text: 'Area',
				path: 'charts/area',
				icon: 'AreaChart',
			},
			chartsColumn: {
				id: 'chartsColumn',
				text: 'Column',
				path: 'charts/column',
				icon: 'BarChart',
			},
			chartsBar: {
				id: 'chartsBar',
				text: 'Bar',
				path: 'charts/bar',
				icon: 'StackedBarChart',
			},
			chartsMixed: {
				id: 'chartsMixed',
				text: 'Mixed',
				path: 'charts/mixed',
				icon: 'MultilineChart',
			},
			chartsTimeline: {
				id: 'chartsTimeline',
				text: 'Timeline',
				path: 'charts/timeline',
				icon: 'WaterfallChart',
			},
			chartsCandleStick: {
				id: 'chartsCandleStick',
				text: 'Candlestick',
				path: 'charts/candlestick',
				icon: 'Cake',
			},
			chartsBoxWhisker: {
				id: 'chartsBoxWhisker',
				text: 'Box Whisker',
				path: 'charts/box-whisker',
				icon: 'SportsMma',
			},
			chartsPieDonut: {
				id: 'chartsPieDonut',
				text: 'Pie & Donut',
				path: 'charts/pie-donut',
				icon: 'PieChart',
			},
			chartsRadar: {
				id: 'chartsRadar',
				text: 'Radar',
				path: 'charts/radar',
				icon: 'BrightnessLow',
			},
			chartsPolar: {
				id: 'chartsPolar',
				text: 'Polar',
				path: 'charts/polar',
				icon: 'TrackChanges',
			},
			chartsRadialBar: {
				id: 'chartsRadialBar',
				text: 'Radial Bar',
				path: 'charts/radial-bar',
				icon: 'DonutLarge',
			},
			chartsBubble: {
				id: 'chartsBubble',
				text: 'Bubble',
				path: 'charts/bubble',
				icon: 'BubbleChart',
			},
			chartsScatter: {
				id: 'chartsScatter',
				text: 'Scatter',
				path: 'charts/scatter',
				icon: 'ScatterPlot',
			},
			chartsHeatMap: {
				id: 'chartsHeatMap',
				text: 'Heat Map',
				path: 'charts/heat-map',
				icon: 'GridOn',
			},
			chartsTreeMap: {
				id: 'chartsTreeMap',
				text: 'Tree Map',
				path: 'charts/tree-map',
				icon: 'AccountTree',
			},
		},
	},
	notification: {
		id: 'notification',
		text: 'Notification',
		path: 'notifications',
		icon: 'NotificationsNone',
	},
	hooks: {
		id: 'hooks',
		text: 'Hooks',
		path: 'hooks',
		icon: 'Anchor',
	},
};

export const productsMenu = {
	companyA: { id: 'companyA', text: 'Company A', path: 'grid-pages/products', subMenu: null },
	companyB: { id: 'companyB', text: 'Company B', path: '/', subMenu: null },
	companyC: { id: 'companyC', text: 'Company C', path: '/', subMenu: null },
	companyD: { id: 'companyD', text: 'Company D', path: '/', subMenu: null },
};
